// extracted by mini-css-extract-plugin
module.exports = {"buttonClose":"styles_buttonClose__3BRoN primary-content_buttonClose__3KcN3","logoutWrapper":"styles_logoutWrapper__3nBWI","logout":"styles_logout__1G3OT"};